import './Spinner.css';

const Spinner = ({ className = '' }) => {
	return <div className={`spinner-border ${className}`} role="status" />;
};

export default Spinner;
